var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndorsementCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 263,
    viewBox: "0 0 291 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.22 68.73L221.84 94.73C221.49 95.84 220.76 96.79 219.79 97.43C218.81 98.06 217.64 98.33 216.48 98.19C216.48 98.19 197.6 98.3 196.92 98.63C190.64 101.69 230.22 68.73 230.22 68.73Z",
    fill: "#080717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.36 252.88L136.71 189.48L72.22 221.18L48.13 230.7C20.6 241.58 -7.04997 215.21 2.53003 187.19C4.17003 182.39 6.77996 177.99 10.2 174.24C13.62 170.5 17.77 167.49 22.39 165.42L132.34 116.24L195.74 100.94L248.33 122.59C255.05 125.35 261.02 129.69 265.71 135.23C270.41 140.78 273.71 147.37 275.33 154.46L289.03 214.46C290.29 219.99 290.35 225.72 289.19 231.26C288.04 236.81 285.7 242.04 282.34 246.61C276.79 254.14 268.74 259.45 259.62 261.59C250.51 263.73 240.94 262.56 232.61 258.29L222 252.88",
    fill: "#FF7B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.41 123.89C173.39 127.21 179.15 129.18 185.13 129.61C191.1 130.04 197.08 128.91 202.49 126.34L207.71 123.85V69.24H168.36L168.41 123.89Z",
    fill: "#FFC89E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.41 203.69L216.75 178.18",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.97 252.88L173.75 210",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.54 25.3799L204.93 15.9099L225.55 58.2999L225.96 58.4199C229.28 59.5999 232 62.0499 233.53 65.2299C235.05 68.4099 235.26 72.06 234.1 75.4C232.95 78.73 230.52 81.47 227.35 83.02C224.18 84.57 220.53 84.8099 217.19 83.6799C216.77 83.5299 216.38 83.3399 215.99 83.1599L212.76 89.34C210.07 94.49 205.99 98.7799 200.98 101.72C195.97 104.66 190.23 106.14 184.42 105.98L167.55 105.51C162.45 105.37 157.6 103.25 154.04 99.59C150.47 95.93 148.48 91.0299 148.48 85.9199V42.9199C148.49 38.8399 149.88 34.8699 152.44 31.6799C154.99 28.4899 158.55 26.2699 162.54 25.3799Z",
    fill: "#FFC89E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201 101.72C195.99 104.66 190.25 106.14 184.44 105.98L167.57 105.51",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.69 38.3799C177.98 30.5199 179.33 18.4799 172.7 11.4699C166.07 4.45988 153.96 5.14992 145.67 13.0099C137.37 20.8699 136.02 32.9099 142.65 39.9199C149.28 46.9299 161.39 46.2399 169.69 38.3799Z",
    fill: "#080717"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8 13.2599C186.25 11.7399 192.46 9.33988 198.26 6.12988C198.82 7.19988 199.25 8.3399 199.54 9.5199C201.82 18.8899 194.67 28.6799 183.54 31.3799C172.41 34.0799 161.54 28.6699 159.31 19.2999C158.99 17.9899 158.86 16.6499 158.91 15.2999C165.93 15.6599 172.97 14.9699 179.8 13.2599Z",
    fill: "#080717"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.06 63.7199C189.16 66.1199 187.8 68.14 186.06 68.21C184.32 68.28 182.75 66.3999 182.65 63.9899C182.55 61.5799 183.91 59.5699 185.65 59.4999C187.39 59.4299 189 61.3099 189.06 63.7199Z",
    fill: "#080717"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.45 43.1599C181.45 43.1599 187.45 42.2999 190.92 46.3799",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.25 61.46C158.35 63.86 156.99 65.88 155.25 65.95C153.51 66.02 151.94 64.1399 151.84 61.7299C151.74 59.3199 153.09 57.3099 154.84 57.2399C156.59 57.1699 158.14 59.05 158.25 61.46Z",
    fill: "#080717"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.6 45.2499C153.6 45.2499 155.81 42.1899 160.3 45.1399",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.71 87.6699C179.71 87.6699 174.55 90.47 170.34 87.95",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.83 52.9601L173.27 65.23C173.63 68.34 175.06 71.2401 177.31 73.4201C179.56 75.6101 182.5 76.95 185.62 77.23C188.91 77.56 192.22 77.5301 195.5 77.1401C201.28 76.3601 204.99 68.5501 207.08 62.1401C207.4 61.1601 207.48 60.12 207.33 59.1C207.17 58.08 206.78 57.1101 206.19 56.2701C205.59 55.4301 204.81 54.7401 203.9 54.2501C202.99 53.7601 201.98 53.5 200.95 53.47L142.16 51.8601C141.47 51.8401 140.78 51.96 140.14 52.22C139.49 52.47 138.9 52.8501 138.41 53.3301C137.91 53.8101 137.52 54.3901 137.25 55.0301C136.98 55.6701 136.84 56.35 136.84 57.04V62.3601C136.84 68.1001 141.2 75.7901 146.93 76.1501L154.06 76.35C155.23 76.38 156.4 76.1801 157.5 75.7601C158.59 75.3401 159.59 74.7001 160.44 73.8901",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.19 65.83L164.36 52.49",
    stroke: "#080717",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M239 43.0801C239.33 31.1201 233.37 21.25 225.7 21.04C218.03 20.83 211.54 30.3601 211.21 42.3201C210.88 54.2801 216.84 64.15 224.51 64.36C232.19 64.57 238.67 55.0401 239 43.0801Z",
    fill: "#080717"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222.11 37.9401C227.69 32.6601 226.83 22.7001 220.19 15.7001C213.56 8.69007 203.67 7.29006 198.09 12.5701C192.52 17.8501 193.37 27.8101 200.01 34.8101C206.64 41.8201 216.54 43.2201 222.11 37.9401Z",
    fill: "#080717"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M226 28.2499C226 28.2499 228.52 4.51988 208.26 2.35988C188 0.199881 159.69 4.92988 155.38 0.359881C154.86 -0.190119 158.25 22.6299 169.45 23.4699C180.65 24.3099 214.77 17.8199 226 28.2499Z",
    fill: "#080717"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.7 54.73L212.15 72.1201C212 72.6801 212.05 73.2801 212.29 73.8101C212.53 74.3401 212.94 74.7701 213.46 75.0301C213.79 75.1901 214.15 75.29 214.51 75.3C214.88 75.31 215.25 75.25 215.58 75.1C215.92 74.96 216.23 74.74 216.47 74.48C216.72 74.21 216.91 73.89 217.02 73.54L223.41 53.8401L216.7 54.73Z",
    fill: "#080717"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.53 73.82C220.53 73.82 221.96 67.95 227.05 66.24",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 61.6599L162.11 67.5599C160.91 68.9999 160.31 70.84 160.43 72.71C160.55 74.58 161.39 76.3299 162.76 77.6099L163.91 78.6799",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M255.85 104.93L247.85 94.06C246.8 92.63 245.49 91.42 243.97 90.5C242.46 89.58 240.78 88.97 239.03 88.7C237.28 88.43 235.49 88.51 233.77 88.93C232.05 89.35 230.43 90.11 229 91.16L55.4399 218.39L79.35 251.02L252.94 123.82C254.38 122.77 255.59 121.45 256.51 119.93C257.43 118.41 258.05 116.73 258.32 114.97C258.59 113.21 258.51 111.42 258.09 109.7C257.66 107.98 256.9 106.35 255.85 104.92V104.93Z",
    fill: "#01304A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M216.13 100.61L239.82 132.93",
    stroke: "#080717",
    strokeWidth: 2.19
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M219.65 98.0301L243.56 130.66L253 123.82C255.88 121.7 257.81 118.53 258.35 114.99C258.89 111.45 258.01 107.85 255.9 104.97L247.9 94.1C246.85 92.67 245.53 91.46 244.02 90.54C242.51 89.62 240.82 89.0101 239.07 88.7401C237.32 88.4701 235.54 88.55 233.82 88.97C232.1 89.39 230.48 90.1501 229.05 91.2001L219.65 98.0301Z",
    fill: "#080717"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5402 218.38L29.3901 262.68L79.5001 251.07L55.5402 218.38Z",
    fill: "#D7E4F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9202 256.99L42.1901 240.99L29.3901 262.68L53.9202 256.99Z",
    fill: "#080717"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M171.14 183.65L164.47 188.54C160.47 191.44 165.47 202.13 169.14 205.33L174.14 209.13C174.14 209.13 191.78 214.98 203.22 200.7C214.66 186.42 227.66 161.41 216.81 150.22C205.96 139.03 193.08 116.54 188.99 127.22C185.92 135.22 202.45 159.05 202.45 159.05L169.09 143.22C169.09 143.22 164.62 148.32 163.86 154.22C163.41 158.15 163.24 162.11 163.35 166.06C163.47 173 164.76 176.18 171.14 183.65Z",
    fill: "#FFC89E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216.77 150.22L194.92 125.22C194.62 124.87 194.25 124.59 193.83 124.4C193.42 124.21 192.96 124.11 192.5 124.11C192.04 124.11 191.59 124.21 191.17 124.4C190.75 124.59 190.38 124.87 190.08 125.22C188.73 126.81 187.91 128.78 187.73 130.86C187.55 132.94 188.02 135.02 189.08 136.82L202.88 160.3",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M211.27 164.82L169 142.82C169 142.82 162.14 147.82 165.75 153.19",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M205.41 177.04L163.36 152.58C163.36 152.58 159.49 160.71 163.54 164.45C167.59 168.19 196.9 187.93 196.9 187.93",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M188.13 196.13C188.13 196.13 158.41 178.55 163.82 164.92",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67 208.53L52.86 218.75C52.86 218.75 46.73 204.21 60.25 191.89C73.77 179.57 97.91 165 109.77 175.12C121.63 185.24 129.36 209.33 129.36 209.33C129.36 209.33 122.28 218.33 117.52 211.15C90.81 171.15 108.85 204.64 108.85 204.64L120.13 222.16C120.13 222.16 114.89 227.89 109.07 229.01C103.25 230.13 82.69 233.75 67 208.53Z",
    fill: "#FFC89E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.24 221.82C51.76 212.27 51.73 199.18 60.24 191.93C74.81 179.58 96.81 165.57 109.76 175.16C122.71 184.75 129.35 209.37 129.35 209.37C129.35 209.37 122.88 217.59 117.56 211.75C112.24 205.91 107.06 191.56 101.61 190.49",
    fill: "#FFC89E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6301 181.53L120.21 222.36C120.21 222.36 115.67 229.52 110.06 226.26",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7601 188.16L110.85 228.57C110.85 228.57 102.98 232.94 98.9901 229.14C95.0001 225.34 73.4302 197.34 73.4302 197.34",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8101 206.61C65.8101 206.61 85.25 235.16 98.5 228.89",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6802 77.5799L47.4302 94.9499L73.5402 67.0699C74.0002 66.5699 74.3402 65.9699 74.5202 65.3199C74.7102 64.6699 74.7301 63.9798 74.5901 63.3098C74.4601 62.6498 74.1602 62.0198 73.7302 61.4898C73.3102 60.9598 72.7602 60.5499 72.1402 60.2699C71.3502 59.9199 70.4702 59.8198 69.6202 59.9898C68.7702 60.1598 68.0002 60.5799 67.4002 61.1999L50.0002 79.0598L45.3401 72.2499C44.7801 71.4299 43.9502 70.8298 42.9902 70.5598C42.0402 70.2898 41.0202 70.3599 40.1102 70.7699L38.5701 71.4599C38.0101 71.6999 37.5202 72.0699 37.1202 72.5199C36.7102 72.9699 36.4102 73.5099 36.2302 74.0899C36.0502 74.6699 36.0001 75.2799 36.0801 75.8799C36.1501 76.4799 36.3602 77.0599 36.6802 77.5699V77.5799Z",
    fill: "#01304A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.76 103.14L93.7601 87.7701C95.6201 83.4001 96.5801 78.7001 96.5801 73.9501C96.5801 53.0201 78.2401 36.0601 55.5801 36.0601C32.9201 36.0601 14.5801 53.0601 14.5801 73.9501C14.5801 94.8401 32.9201 111.85 55.5801 111.85C61.8101 111.93 67.9801 110.62 73.6401 108.02C79.3101 105.42 84.3201 101.6 88.3301 96.8201L103.76 103.14Z",
    stroke: "#01304A",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndorsementCheckmark);
export default __webpack_public_path__ + "static/media/endorsement_checkmark.13677846dc268d634252af51d673f1d2.svg";
export { ForwardRef as ReactComponent };